import { formatDateTimeMX } from '@/shared/lib/dateUtils'
import { JobRequestStatus } from '@/services/api'
import type { JobRequest } from '@/services/api'

interface RequestTimelineProps {
  request: JobRequest
}

interface TimelineItem {
  status: string
  label: string
  date?: string
  user?: string
  isActive: boolean
  isCompleted: boolean
}

export const RequestTimeline = ({ request }: RequestTimelineProps) => {
  const getTimelineItems = (): TimelineItem[] => {
    const items: TimelineItem[] = [
      {
        status: JobRequestStatus.PENDIENTE_VALIDACION_PM,
        label: 'Pendiente Pre-aprobación',
        date: request.fechaCreacion,
        user: request.solicitante ? `${request.solicitante.firstName} ${request.solicitante.lastName}` : 'Usuario no disponible',
        isActive: request.status === JobRequestStatus.PENDIENTE_VALIDACION_PM,
        isCompleted: true
      },
      {
        status: JobRequestStatus.EN_REVISION,
        label: 'Pre-aprobada',
        date: request.fechaRevision ? request.fechaRevision.toString() : undefined,
        user: request.revisadoPor ? `${request.revisadoPor.firstName} ${request.revisadoPor.lastName}` : undefined,
        isActive: request.status === JobRequestStatus.EN_REVISION,
        isCompleted: [
          JobRequestStatus.EN_REVISION,
          JobRequestStatus.DEVUELTA,
          JobRequestStatus.APROBADA,
          JobRequestStatus.RECHAZADA
        ].includes(request.status as any)
      }
    ]

    // Agregar estado de devuelta si aplica
    const finalStates = [JobRequestStatus.DEVUELTA, JobRequestStatus.APROBADA, JobRequestStatus.RECHAZADA]
    if (finalStates.includes(request.status as any)) {
      if (request.status === JobRequestStatus.DEVUELTA) {
        items.push({
          status: JobRequestStatus.DEVUELTA,
          label: 'Devuelta para Información',
          date: request.fechaRevision ? request.fechaRevision.toString() : undefined,
          user: request.revisadoPor ? `${request.revisadoPor.firstName} ${request.revisadoPor.lastName}` : undefined,
          isActive: true,
          isCompleted: true
        })
      } else {
        // Estado final (aprobada o rechazada)
        items.push({
          status: request.status,
          label: request.status === JobRequestStatus.APROBADA ? 'Vacante Activa' : 'Rechazada',
          date: request.fechaRevision ? request.fechaRevision.toString() : undefined,
          user: request.revisadoPor ? `${request.revisadoPor.firstName} ${request.revisadoPor.lastName}` : undefined,
          isActive: true,
          isCompleted: true
        })
      }
    }

    return items
  }

  const formatDate = (dateString?: string) => {
    if (!dateString) return ''
    return formatDateTimeMX(dateString)
  }

  const timelineItems = getTimelineItems()

  return (
    <div className="request-timeline">
      <h4 className="timeline-title">Estado de la Solicitud</h4>
      <div className="timeline-container">
        {timelineItems.map((item, index) => (
          <div
            key={`${item.status}-${index}`}
            className={`timeline-item ${item.isActive ? 'active' : ''} ${item.isCompleted ? 'completed' : ''}`}
          >
            <div className="timeline-marker"></div>
            <div className="timeline-content">
              <div className="timeline-header">
                <h5 className="timeline-label">{item.label}</h5>
              </div>
              {item.date && (
                <span className="timeline-date">{formatDate(item.date)}</span>
              )}
              {item.user && (
                <p className="timeline-user">Por: {item.user}</p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
